import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import Popup from 'components/popup/popup';
import { getTimeWithTimeZone, emptyShow } from 'utility/general';

const useStyles = makeStyles((theme) => ({
    container: {
        flex: 1,
        overflow: 'auto',
    },
    title: {
        fontWeight: 'bold',
    },
    item: {
        marginTop: 10,
    },
    radioGroup: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
    },
    formGroup: {
        width: '100%',
    },
    formLabel: {
        fontWeight: 'bold',
        padding: '12px 16px 0 0',
    },
    value: {
        padding: '5px 0',
    },
    listSubheader: {
        background: '#fff',
    },
    menuItem: {
        paddingLeft: '26px',
    },
}));

const ViewDetails = (props) => {
    const classes = useStyles();

    const rowData = props.rowData ? props.rowData : null;
    const lastLoginDtm = emptyShow(
        rowData && rowData.lastLoginDtm ? getTimeWithTimeZone(rowData.lastLoginDtm).format('YYYY-MM-DD HH:mm:ss') : '',
    );

    const close = () => {
        props.setOpenPopup(false);
    };

    const footerActions = [{ label: 'Close', clicked: close }];

    return (
        <Popup
            height="70%"
            width="550px"
            title={'View Account Details'}
            open={props.openPopup}
            footerActions={footerActions}
            closePopup={close}
        >
            <Grid container wrap="nowrap" direction="column" className={classes.container}>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        Email:
                    </Grid>
                    <Grid container item xs={9}>
                        <Typography className={classes.value}>{emptyShow(rowData.email)}</Typography>
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        Title:
                    </Grid>
                    <Grid container item xs={9}>
                        <Typography className={classes.value}>{emptyShow(rowData.title)}</Typography>
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        Full Name:
                    </Grid>
                    <Grid container item xs={9}>
                        <Typography className={classes.value}>{emptyShow(rowData.fullName)}</Typography>
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        Hospital / Institution:
                    </Grid>
                    <Grid container item xs={9}>
                        <Typography className={classes.value}>{emptyShow(rowData.institution)}</Typography>
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        Contact Number:
                    </Grid>
                    <Grid container item xs={9}>
                        <Typography className={classes.value}>{emptyShow(rowData.contact)}</Typography>
                    </Grid>
                </Grid>
                {rowData ? (
                    <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                        <Grid container item xs={3} className={classes.title}>
                            Justification:
                        </Grid>
                        <Grid container item xs={9}>
                            <Typography className={classes.value}>{emptyShow(rowData.justification)}</Typography>
                        </Grid>
                    </Grid>
                ) : null}
                <Grid container wrap="nowrap" alignItems="baseline" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        User Group:
                    </Grid>
                    <Grid container item xs={9}>
                        <Grid className={classes.value}>{emptyShow(rowData.userGroup)}</Grid>
                    </Grid>
                </Grid>
                {[0, 3].includes(rowData.status) && (
                    <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                        <Grid container item xs={3} className={classes.title}>
                            Enable:
                        </Grid>
                        <Grid container item xs={9}>
                            <Typography className={classes.value}>{rowData.status === 3 ? 'No' : 'Yes'}</Typography>
                        </Grid>
                    </Grid>
                )}

                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        Last Login:
                    </Grid>
                    <Grid container item xs={9}>
                        <Typography className={classes.value}>{lastLoginDtm}</Typography>
                    </Grid>
                </Grid>

                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        Description:
                    </Grid>
                    <Grid container item xs={9}>
                        <Typography className={classes.value}>{emptyShow(rowData.description)}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Popup>
    );
};

export default ViewDetails;
